module.exports = __webpack_public_path__ + "static/media/ods.0ce35a9f.png";